import { render, staticRenderFns } from "./BreadCrumbNew.vue?vue&type=template&id=2fb56f3a&scoped=true&"
import script from "./BreadCrumbNew.vue?vue&type=script&lang=ts&"
export * from "./BreadCrumbNew.vue?vue&type=script&lang=ts&"
import style0 from "./BreadCrumbNew.vue?vue&type=style&index=0&id=2fb56f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb56f3a",
  null
  
)

export default component.exports